// @ts-nocheck — legacy Rodeo globals reducer; frozen, not extended for LeadNova
import { ActionExtended } from "../../../_common/interfaces/ActionExtended";

export interface GlobalReducer {
  settings: any;
}

const initialState: GlobalReducer = {
  settings: null,
};

const globalsReducer = (state = initialState, _action: ActionExtended) => {
  return state;
};

export default globalsReducer;
